<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import EditIndividualBusinessModal from '../components/EditIndividualBusinessModal.vue';
import { useEditIndividualBusinessStore } from '../pages/useEditIndividualBusinessStore';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import { i18n } from '@/i18n';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import { onMounted } from 'vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';

const t = i18n.t;

const store = useEditIndividualBusinessStore();
const { state } = storeToRefs(store);

onMounted(async () => {
  state.value.isBaseBusinessView = true;
  await store.initialization();
});
</script>
<template>
  <div class="edit-individual-business">
    <div class="edit-individual-business__header__filter-pagination">
      <FilterModalButton
        filter-modal-type="editIndividualBusiness"
        :select-input-index="50"
        :filter-items="store.getFilterItemsValue().value"
        @apply="(filteredContent) => store.onAppliedFilterModal(filteredContent)"
      />
      <Pagination
        :paging-options="state.tableInfo.pagingState"
        :is-loading="isLoading(state.tableInfo.loadingState.status)"
        @on-change-page="store.onChangePaging($event)"
      />
    </div>
    <NewBaseTableContent
      :key="state.renderingKey"
      :prop-table-content-properties="state.tableInfo.tableContentProperties"
      :prop-display-objects="state.tableInfo.tableContentItems"
      :prop-loading-status="state.tableInfo.loadingState"
      :prop-table-type="'editIndividualBusiness'"
      @on-click-sort="(sortKey, isAsc) => store.sortTableContentItems(sortKey, isAsc)"
    />
    <EditIndividualBusinessModal />
    <InfoModal :modal-state="state.modalState.isOpening.loading" icon="loading" :enable-outside-click="false">
      <template #title> {{ t('編集中です・・・') }} </template>
    </InfoModal>
    <InfoModal
      :modal-state="state.modalState.isOpening.commonError"
      icon="error"
      color-style="error"
      :back-button-label="t('確認')"
      :enable-outside-click="false"
      is-disabled-next-button
      @on-back="
        () => {
          state.modalState.isOpening.commonError = false;
          state.modalState.isOpening.edit = true;
        }
      "
    >
      <template #title>{{ t('エラーが発生しました') }}</template>
      <template #description> {{ t('サーバーエラーが発生しました。') }} <br />{{ t('時間をおいて再度お試しください。') }} </template>
    </InfoModal>
    <InfoModal
      :modal-state="state.modalState.isOpening.duplicationError"
      icon="error"
      color-style="error"
      :back-button-label="t('確認')"
      :enable-outside-click="false"
      is-disabled-next-button
      @on-back="
        () => {
          state.modalState.isOpening.duplicationError = false;
          state.modalState.isOpening.edit = true;
        }
      "
    >
      <template #title>{{ t('既存の取引が存在します') }}</template>
      <template #description>{{ t('編集後の取引は既に存在するため、編集ができませんでした。') }} </template>
    </InfoModal>
    <InfoModal
      :modal-state="state.modalState.isOpening.success"
      :next-button-label="t('確認')"
      :enable-outside-click="false"
      @on-next="async () => await store.initialization()"
    >
      <template #title>{{ t('編集完了しました') }}</template>
    </InfoModal>
  </div>
</template>
<style lang="scss" scoped>
.edit-individual-business {
  display: grid;
  gap: 8px;

  &__title {
    font-family: Noto Sans JP;
    font-size: 22px;
    font-weight: 700;
    line-height: 31.86px;
    text-align: left;
    color: $textDefault;
  }

  &__header {
    &__filter-pagination {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: space-between;
    }
  }
}
</style>
